export default class BlockFaq {
  constructor(element) {
    this.element = element

    this.items = element.querySelectorAll('.js-faq-item')
    this.items.forEach((item) => {
      const question = item.querySelector('.js-faq-question')
      const answer = item.querySelector('.js-faq-answer')
      const answerContainer = item.querySelector('.js-faq-answer-container')
      item.addEventListener('click', () => {
        if(item.classList.contains('js-faq-opened')){
            answer.style.height = '0px'
            item.classList.remove('js-faq-opened')
        }else{
            answer.style.height = answerContainer.scrollHeight + 'px'
            item.classList.add('js-faq-opened')
        }
      })
    })
  }
}
